import {MixConfiguration, MixForm} from '../../../fields/mix/types'
import {CreateFormInput} from '../types'

export const buildMixForm = ({
  configuration: {mix}
}: CreateFormInput<MixConfiguration>): MixForm => {
  // Without quote selection, keep materials of all contracts selectable.
  const shouldPreselectContract =
    mix.restrictMaterialsToSelectedContract || mix.contracts.length === 1
  const processContract = shouldPreselectContract ? mix.contracts[0] : undefined
  return {
    contract: {
      contractNumber: processContract?.contractNumber,
      contractItemPositionNumber: undefined
    },
    material: undefined,
    materialVariations: undefined
  }
}
